import React from "react";

export default function BankAccountDeleteDialog(){
    return(
        <>
        BankAccountDeleteDialog
        </>
    )
}